module.exports = __webpack_public_path__ + "static/img/beta_bg_white_05.4bb29aa6.svg";